module.exports = __webpack_public_path__ + "static/product3-b-77c3c255ea86f56f164fe2d60e0686f1.png";